import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { TWDataTable, TWSelect, EmptyState } from '../../../components/ui';
import { headerCls } from '../../../data/columns';
import { formatCurrency } from '../../../utils/baseUtils';
import ReferralStatusBadge from './ReferralStatusBadge';

dayjs.extend(utc);

const fmtDate = (value) =>
  value ? dayjs.utc(value).format('MMM D, YYYY') : '—';

// Değerler string — orchestrator'daki historyStatus ile tip uyumu için.
const STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: '0', label: 'Pending' },
  { value: '5', label: 'Under review' },
  { value: '10', label: 'Active' },
  { value: '20', label: 'Expired' },
  { value: '30', label: 'Revoked' },
  { value: '40', label: 'Rejected' },
];

const columns = [
  {
    title: <span className={headerCls}>Restaurant</span>,
    key: 'restaurant',
    render: (_, row) => (
      <span className="text-sm font-semibold text-slate-900 dark:text-slate-100">
        {row.referredcompanyname || '—'}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Reward</span>,
    key: 'reward',
    render: (_, row) => (
      <span className="text-sm tabular-nums text-slate-700 dark:text-slate-300">
        {formatCurrency(row.rewardamount)}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Status</span>,
    key: 'status',
    render: (_, row) => (
      <ReferralStatusBadge
        kind="status"
        code={row.status}
        fallbackLabel={row.statusname}
      />
    ),
  },
  {
    title: <span className={headerCls}>Invited</span>,
    key: 'invited',
    render: (_, row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {fmtDate(row.createdate)}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Activated</span>,
    key: 'activated',
    render: (_, row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {fmtDate(row.activatedat)}
      </span>
    ),
  },
  {
    title: <span className={headerCls}>Expires</span>,
    key: 'expires',
    render: (_, row) => (
      <span className="text-sm text-slate-600 dark:text-slate-300">
        {fmtDate(row.expiresat)}
      </span>
    ),
  },
];

const ReferralHistoryTable = ({
  data,
  loading,
  pagination,
  onPageChange,
  status,
  onStatusChange,
}) => {
  const hasFilter = status !== '';
  const isEmpty = !loading && (!data || data.length === 0);

  return (
    <div className="space-y-3">
      <div className="w-full sm:w-56">
        <TWSelect
          value={status}
          onChange={onStatusChange}
          allowClear={false}
          aria-label="Filter referrals by status"
          options={STATUS_OPTIONS}
        />
      </div>

      {isEmpty ? (
        <EmptyState
          variant="dashed"
          title="No referrals yet"
          description={
            hasFilter
              ? 'No referrals match this filter.'
              : 'Invite a restaurant to start earning credit.'
          }
        />
      ) : (
        <TWDataTable
          columns={columns}
          data={data}
          rowKey="id"
          loading={loading}
          pagination={
            pagination && pagination.totalRecords > pagination.pageSize
              ? {
                  current: pagination.pageNumber,
                  pageSize: pagination.pageSize,
                  total: pagination.totalRecords,
                  showSizeChanger: false,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} referrals`,
                  onChange: onPageChange,
                }
              : undefined
          }
        />
      )}
    </div>
  );
};

export default ReferralHistoryTable;
